<script>
	export let title;
	export let subtitle;
	export let buttons;
	export let image;
</script>

<main>
	<div class="header">
		<img class="img-header" src="{image}" alt=""/>
		<h1>{title}</h1>
		<h2>{subtitle}</h2>
	</div>
	<div class="button-list">
		{#each buttons as b}
			<div class="box">
				<a href="{b.link}">
					<p>{b.title}</p>
				</a>
			</div>
		{/each}
	</div>
</main>

<style>
	main {
		text-align: center;
		margin: 0 auto;
		line-height: 1.5;
	}

	h1 {
		color: white;
		font-size: 16px;
		font-weight: 500;
		text-overflow: ellipsis;
		max-width: 100%;
		white-space: nowrap;
		overflow: hidden;
		font-family: Inter;
	}
	h2 {
		color: rgba(255, 255, 255, 0.6);
		font-size: 14px;
		font-weight: 500;
		text-overflow: ellipsis;
		max-width: 100%;
		white-space: nowrap;
		overflow: hidden;
		font-family: Inter;
	}

	.header > h1 {
		margin:0px;
	}

	.header > h2 {
		margin:0px;
	}


	.box > a {
		margin: 0px;
    border: none;
    font-family: inherit;
    font-weight: inherit;
    font-size: inherit;
    text-align: center;
    cursor: pointer;
    background: none;
    text-decoration: none;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    height: auto;
    position: relative;
    padding: 16px 20px;
    width: 100%;
    appearance: none;
    box-sizing: border-box;
    vertical-align: middle;
	}

	.box > a > p {
		padding: 0px;
		margin: 0px;
		line-height: 1.5;
		width: 100%;
		font-weight: 500;
		font-size: 14px;
		color:white;
		font-family: Inter;
	}

	.box {
		z-index: 0;
		overflow: hidden;
		margin-bottom: 16px;
		border: none;
		background-color: rgb(101 70 37);
		color: rgb(255, 255, 255);
		transition: transform 0.15s cubic-bezier(0, 0.2, 0.5, 3) 0s;

		position: relative;
		height: auto;
		border-radius: 14px;
	}

	.header {
		margin-top: 12px;
		margin-bottom: 32px;
	}
	.img-header {
		border-radius: 50%;
		width: 96px;
		height: 96px;
		margin-bottom: 16px;
	}

	.button-list {
		max-width:680px;
		margin:auto;
	}
</style>